import { z } from "zod";

export const personDtoSchema = z.object({
  id: z.number(),
  firstname: z.string(),
  lastname: z.string(),
});

export type TPersonDto = z.infer<typeof personDtoSchema>;
